
/**
 * 
 * @param {{
 *   doctors: {
 *     _id: string;
 *     semble: {
 *       [key: string]: {id: string; name: string; email: string;}
 *     };
 *     [key: string]: any;
 *   }[];
 *   fromUserId: string;
 *   toUserId: string;
 *   groupId: string;
 *   hasSemble: boolean;
 * }} obj 
 * @returns {null | string}
 */
export const getSembleUserError = (obj) => {
    try {
        if (obj && obj?.hasSemble && obj.doctors && Array.isArray(obj.doctors) && obj.doctors.length > 0 && obj.fromUserId && obj.toUserId && obj.groupId && typeof obj.fromUserId === 'string' && typeof obj.toUserId === 'string' && obj.fromUserId !== obj.toUserId && typeof obj.groupId === 'string' && obj.fromUserId.toLocaleLowerCase() !== 'none' && obj.toUserId.toLocaleLowerCase() !== 'none') {
            const from = obj.doctors.find(doc => doc?._id === obj.fromUserId);
            const to = obj.doctors.find(doc => doc?._id === obj.toUserId);
            if (from && to) {
                if (from?.semble?.[obj.groupId]?.id && !to?.semble?.[obj.groupId]?.id) {
                    return 'Selected user does not have connected Semble account. If you proceed with transfer, no changes will be made in Semble Dashboard. To keep sync with Semble, please connect the user to Semble account in Group users settings page.';
                }
            }
        }
    } catch (err) {
        console.error('getSembleUserError', err);
    }
    return null;
}